import { useConfig, useMachineState } from '../app/context';
import { CheckList } from '../components/CheckList';
import { cx } from '../components/cx';
import { LINK_CHECKS } from '../domain/catalog';
import { TIMING } from '../domain/timing';
import common from './common.module.css';
import styles from './ConnectScreen.module.css';

export function ConnectScreen() {
  const { phaseElapsed } = useMachineState();
  const { unitId } = useConfig();
  const linked = phaseElapsed >= TIMING.linkSecure;

  return (
    <section
      className={cx(common.screen, common.fadeUp, styles.screen, linked && styles.linked)}
      aria-label="Connecting to robot"
    >
      <div className={styles.radar} aria-hidden>
        <svg className={styles.radarSvg} width="300" height="300" viewBox="0 0 300 300">
          <circle className={styles.track} cx="150" cy="150" r="138" fill="none" strokeWidth="2" />
          <circle
            className={styles.sweep}
            cx="150"
            cy="150"
            r="128"
            fill="none"
            strokeWidth="4"
            strokeLinecap="round"
            strokeDasharray="40 22"
          />
          <circle
            className={styles.orbit}
            cx="150"
            cy="150"
            r="100"
            fill="none"
            strokeWidth="1"
            strokeDasharray="4 10"
          />
        </svg>
        {linked && (
          <>
            <div className={styles.lockRing} />
            <div className={styles.lockRing} />
          </>
        )}
        <div className={styles.unit}>
          <div className={styles.unitMark}>EVX</div>
          <div className={styles.unitId}>{unitId}</div>
        </div>
      </div>

      <div className={styles.panel}>
        <div className={common.kicker}>UPLINK SEQUENCE</div>
        <h2 className={styles.title} role="status">
          {linked ? 'CONNECTED TO EVESIX' : 'ESTABLISHING SECURE LINK'}
        </h2>
        <div className={styles.subtitle}>
          {linked
            ? "You're all set — heading to zone selection."
            : 'Connecting to the robot… please hold on.'}
        </div>
        <CheckList variant="link" checks={LINK_CHECKS} elapsed={phaseElapsed} lookahead={0.4} />
        {linked && <div className={styles.banner}>[ LINK ESTABLISHED — UNIT READY ]</div>}
      </div>
    </section>
  );
}
